/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：631
 */

module.exports = function (e, t) {
  return {
    enumerable: !(1 & e),
    configurable: !(2 & e),
    writable: !(4 & e),
    value: t
  }
}
